<template>
  <div v-show="showApp" class="tran-page">
    <div class="fixed-main">
      <Header :config="headConfig" @handleAddApp="handleAddApp" />
      <div class="main">
        <van-search 
          v-if="pageType==='keywordAppList'"
          v-model="searchVal" 
          placeholder="Search Your App"
          show-action
          @search="onSearch"
        >
          <template #action>
            <div class="search" @click="onSearch">Search</div>
          </template>
        </van-search>
        <div v-if="appList.length===0&&orderType!=='aso'">
          <NullData />
        </div>
        <div v-else>
          <div v-if="orderType==='aso'" class="flex align-center"  @click="handleApp('no')" style="padding:10px;">
            <span>(no app)</span>
          </div>
          <AppItem
            v-for="item in appList"
            :key="item._id"
            :data="item.appInfo"
            @handleApp="handleApp"
          />
        </div>
        
      </div>
      <Loading :loading="loading" />
      <Loading :loading="searchLoading" :top="120" />
    </div>
    <transition name="slide">
      <AddApp ref="AddApp" :platform="form.form" @addSuccess="addSuccess" />
    </transition>
  </div>
</template>

<script>
import { post } from 'src/utils/request.js'
import Loading from 'components/Loading'
import {
  getCurrentInstance,
  ref,
  toRefs,
  reactive,
  onMounted,
  onBeforeMount,
  watch,
} from 'vue'
import event from 'utils/eventBus'
import { useStore } from 'vuex'

export default {
  name: 'MyApps',
  components: { Loading },
  props: {
    platform: {
      type: Number,
      default: 1,
    },
    pageType: {
      type: String,
      default: '',
    },
    orderType: {
      type: String,
      default: '',
    },
  },
  //import 引入组件
  emits:['handleChange'],
  setup(props, {emit}) {
    const instance = getCurrentInstance()
    const api = instance.appContext.config.globalProperties.$url
    const store = useStore()
    const AddApp = ref(false)
    const loading=ref(true)
    let handleAddApp = () => {
      AddApp.value.openAppBox()
    }
    
    const form=reactive({
      form:props.platform
    })
    let headConfig = {
      callBackName: 'appBack',
      type: 'other',
      title: 'Your Apps',
      actionTitle:(props.pageType==='order'||props.pageType==='keywordAppList')?'':'+Add New App',
      actionEvent: 'handleAddApp',
    }
    let data = reactive({
      appList: []
    })
    let showApp = ref(false)

    let init = async () => {
      loading.value=true
      if(props.platform==='no'){
        loading.value=false
      }else{
      let platform =  props.platform? form.form:props.platform
        let res = await post(api.HOME_GET_LIST, {platform ,iosPlat:platform})
        if (res.code === 0) {
          data.appList = res.data.list.map((item)=>{
           item.appInfo.platform = item.platform
           return item
          })
          loading.value=false
        }
      }
      
    }
    const open = () => {
      form.form=props.platform
      showApp.value = true
      if(searchVal.value){
        searchVal.value=''
      }
      init()
    }
    const handleApp = (val) => {
      // const appInfo = appList.find((item) => item.appId === appId)
      if(val!=='no'){
          store.commit('dashboard/setApp', {
          basic: { platform: form.form },
          appInfo: val
        })
      }
      showApp.value = false
      emit('handleChange', val)
    }
    const addSuccess=(val)=>{
      form.form=val
      init()
    }
    const changeStore=(val)=>{
      form.form=val
    }
    watch(()=>props.platform,(val)=>{
      form.form=val
    })
    onMounted(() => {
      event.$on('handleAddApp', () => {
        handleAddApp()
      })
      event.$on('appBack', () => {
        showApp.value = false
      })
    })
    onBeforeMount(() => {
      event.$off('appBack')
      event.$off('handleAddApp')
    })
    const searchVal = ref('')
    const searchLoading=ref(false)
    const onSearch = async() => {
      searchLoading.value = true
      data.appList= []
      const res = await post(api.HOME_GET_LIST, {
        appName: searchVal.value,
        platform: props.platform
      })
      if (res.code === 0) {
        data.appList = res.data.list;
      }
      searchLoading.value = false
    };
    return {
      ...toRefs(data),
      headConfig,
      AddApp,
      handleApp,
      open,
      showApp,
      handleAddApp,
      addSuccess,
      loading,
      changeStore,
      form,
      onSearch,
      searchVal,
      searchLoading
    }
  },
}
</script>

<style scoped lang="scss">
.fixed-main {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10000;
  background: #f6f5ff;

  .main {
    padding: 0 10px;
    position: absolute;
    top: 58px;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;
    background: #fff;

    // & > div:last-child {
    //   margin-bottom: 8px;
    //   border-bottom: 1px solid #f2f3f5;
    // }

    .search {
      height: 34px;
      background: #1c82f4;
      color: #fff;
      border-radius: 3px;
      font-size: 13px;
      padding: 0 5px;
    }
  }
}
</style>
